const zeroMargin = {top:0, right:0, bottom:0, left:0};
function offset() {  
  if (this.zeroOffset()) return zeroMargin;
  let offset = Object.assign({}, this.zeroMargin() ? zeroMargin : this.margin());
  let axisToggle = this.axis();
  let legend = this.legend();
  if (!this.noAxisOffset()) {
    axisToggle.forEach(function(at) {
      offset[at.orient] += at.thickness;
    })
  }
  if(legend) offset[legend.orient] += legend.thickness;
  return offset;
}

export default offset;


// WEBPACK FOOTER //
// ./layouts/default/offset.js